import api from './client';

interface TenantConfig {
  tier: string;
  features: Record<string, boolean>;
}

export async function fetchTenantConfig() {
  const res = await api.get<TenantConfig>('/tenant/config');
  return res.data;
}
